<template>
  <div>
    <van-nav-bar left-text="消息通知" left-arrow @click-left="onClickLeft">
    </van-nav-bar>
    <ul class="events_list">
      <li class="title">{{ data.title }}
      </li>
      <li class="cent">{{ data.content }}
      </li>
      <li class="cent">{{ data.time }}
      </li>
      <li v-if="data.img">
        <img :src="require('../../assets/message/' + data.img)">
      </li>
    </ul>
  </div>
</template>
<script>
import listJson from './message.json'
export default {
  data() {
    return {
      data: {}
    }
  },
  mounted() {
    // 回获取路由参数
    const { id } = this.$route.query;
    let data = listJson.find(item => item.id === id);
    this.data = data;
    console.log(data);

  },
  methods: {
    onClickLeft() {
      this.$router.push({ path: '/message', query: { active: 2 } })
    }
  },
}
</script>
<style lang="less" scoped>
.events_list {
  padding: 20px;

  .title {
    font-size: 0.14rem;
    font-weight: bold;
    color: #333;
    // 文字溢出显示。。。
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }

  .cent {
    margin: 10px 0;
    line-height: 20px;
  }

  img {
    width: 100%;
  }
}
</style>